import { duration } from 'moment';
import { DayOfWeek } from 'core/day-of-week';
import { Translate } from 'hooks/use-translation';
import { minsToHours } from '../financials/utils/common';
import { Hours, Minutes, WorkingDaysConfiguration } from './types';

export const MINUTES_IN_A_DAY = 1440; // 24 * 60
export const DEFAULT_CAPACITY_MINUTES_PER_DAY = 480; // 8h per day
export const DEFAULT_CAPACITY_MINUTES_PER_WEEK = 2400; // 40 h/week
export const MAX_CAPACITY_MINUTES_FOR_A_WEEK =
  duration(24, 'hours').asMinutes() * 7; // TODO: Check with PM if we need to do capacity * 7 or capacity * noOfWorkingDays?

export const DefaultWorkingDayConfig: WorkingDaysConfiguration = {
  [DayOfWeek.Monday]: true,
  [DayOfWeek.Tuesday]: true,
  [DayOfWeek.Wednesday]: true,
  [DayOfWeek.Thursday]: true,
  [DayOfWeek.Friday]: true,
  [DayOfWeek.Saturday]: false,
  [DayOfWeek.Sunday]: false,
};

export const getNumberOfWorkingDaysInAWeek = (
  workingDaysConfig: WorkingDaysConfiguration = DefaultWorkingDayConfig,
) => Object.values(workingDaysConfig).filter(Boolean).length;

export const getCapacityInMinutesForADay = (
  capacityMinutes: Minutes,
  workingDays: WorkingDaysConfiguration = DefaultWorkingDayConfig,
): Minutes => {
  const numberOfWorkingDays = getNumberOfWorkingDaysInAWeek(workingDays);

  return Math.floor(capacityMinutes / numberOfWorkingDays);
};

export const getCapacityInHoursForADay = (
  capacityMinutes: Minutes,
  workingDays: WorkingDaysConfiguration = DefaultWorkingDayConfig,
): Hours => {
  return minsToHours(getCapacityInMinutesForADay(capacityMinutes, workingDays));
};

export const userCapacityFormValidator = (
  value: any,
  translate: Translate,
  onResolve?: () => void,
  onReject?: () => void,
) => {
  if (value <= 0 || value > MAX_CAPACITY_MINUTES_FOR_A_WEEK) {
    onReject?.();

    return Promise.reject(
      new Error(translate('settings.weekly_capacity.input.error')),
    );
  }

  onResolve?.();

  return Promise.resolve();
};

export const validateAndRoundOffInputDuration = (
  value: number,
  workingDaysConfig: WorkingDaysConfiguration = DefaultWorkingDayConfig,
): number => {
  const numberOfWorkingDays = getNumberOfWorkingDaysInAWeek(workingDaysConfig);

  return Math.round(value / numberOfWorkingDays) * numberOfWorkingDays;
};
